import { BotProviderUserSettings, useGetApiBotProviderUserSettingsGet, usePostApiBotProviderUserSettingsUpsert } from "@/API";
import { DateToTimestamp, TimestampToDate, getRecentTimePresets } from "@/Helpers/DateHelper";
import { Badge, Box, Button, Group, Modal, Switch, TagsInput, Text, TextInput } from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { PropsWithChildren, useEffect, useMemo, useState } from "react";

export function BotProviderUserSettingsButton(props: { workspaceId: string, botProviderId: string, userId: string, onUpdate?: () => void } & PropsWithChildren) {
    const queryClient = useQueryClient()
    const [opened, { open, close }] = useDisclosure(false);
    const data = useGetApiBotProviderUserSettingsGet({ workspaceId: props.workspaceId, botProviderId: props.botProviderId, userId: props.userId })
    const Upsert_Mutation = usePostApiBotProviderUserSettingsUpsert()
    const [loading, setLoading] = useState(false)
    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="User設定" size="xl">
            {
                data.data?.data && <BotProviderUserSettingsForm loading={loading} initValue={data.data.data} onChange={async values => {
                    values.id = data.data?.data.id ?? ""
                    values.workspaceId = props.workspaceId
                    values.botProviderId = props.botProviderId
                    values.userId = props.userId
                    setLoading(true)
                    try {
                        await Upsert_Mutation.mutateAsync({
                            params: {
                                workspaceId: props.workspaceId
                            }, data: values
                        })
                        queryClient.invalidateQueries({
                            queryKey: data.queryKey
                        })
                        notifications.show({ message: "更新成功" })
                        props.onUpdate?.()
                    } catch (e) {
                        notifications.show({ message: "更新失敗", color: "red" })
                    }
                    setLoading(false)
                    close()
                }} />
            }
        </Modal>
    </>
}
export function BotProviderUserSettingsForm(props: { initValue: BotProviderUserSettings, onChange: (value: BotProviderUserSettings) => void, loading?: boolean }) {
    const form = useForm<BotProviderUserSettings>({
        initialValues: props.initValue
    });
    useEffect(() => {
        form.setValues(props.initValue)
    }, [props.initValue])

    const recentPresets = useMemo(() => getRecentTimePresets(), []);

    return <>
        <form onSubmit={form.onSubmit(async (values) => {
            props.onChange(values)
        })}>
            <TextInput
                label="名稱"
                {...form.getInputProps('name')}
            />
            <Switch
                mt="md"
                label="關閉自動回應"
                description="啟用此功能後，機器人就不會再自動回應使用者"
                {...form.getInputProps('disableReply', { type: "checkbox" })}
            />
            <TagsInput
                label="Tags"
                {...form.getInputProps('tags')}
            />
            <Box mt="md">
                <DateTimePicker
                    label="歷史紀錄起點"
                    placeholder="選擇歷史起點時間"
                    valueFormat="YYYY/MM/DD HH:mm:ss"
                    withSeconds
                    clearable
                    presets={recentPresets}
                    value={form.values.historyStartTimestamp ? TimestampToDate(form.values.historyStartTimestamp) : null}
                    onChange={(val) => form.setFieldValue("historyStartTimestamp", val ? DateToTimestamp(new Date(val)) : 0)}
                />
                <Text size="xs" c="dimmed" mt={4}>
                    此時間點之前的聊天紀錄不會被載入至 AI 對話上下文，使用者端亦會隱藏。管理員仍可檢視完整歷史。
                </Text>
            </Box>
            <Group justify="flex-end" mt="md">
                <Button type="submit" loading={props.loading}>確認</Button>
            </Group>
        </form>
    </>
}